import React,{useState} from 'react'
import Chart from 'react-apexcharts';
function SubHeadGraphs() {
   const [selectedCategory, setSelectedCategory] = useState('Expenses');

  // Sample data for the charts
  const budgetData = {
    categories: ['Mar 2023', 'Apr 2023', 'May 2023', 'Jun 2023', 'Jul 2023', 'Aug 2023', 'Sep 2023', 'Oct 2023', 'Nov 2023', 'Dec 2023', 'Jan 2024', 'Feb 2024'],
    expected: [2800, 2700, 2600, 2930, 3000, 2500, 2600, 2230, 4200, 3000, 2800, 2400],
    actual: [2600, 2500, 2500, 2700, 2800, 2300, 2400, 4300, 4200, 3000, 2200, 2100],
    percentages: [7, null, 5, 27, 16, 20, 16, 48, 100, 100, 18, 29]
  };

  const expenseGrowthData = {
    categories: ['Mar 2023', 'Apr 2023', 'May 2023', 'Jun 2023', 'Jul 2023', 'Aug 2023', 'Sep 2023', 'Oct 2023', 'Nov 2023', 'Dec 2023', 'Jan 2024', 'Feb 2024'],
    growth: [-5, -7, 0, 13, -11, 0, -10, 1, 3, -14, 1, 0]
  };

  const budgetChartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false },
      background: 'transparent'
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '70%',
        borderRadius: 4,
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        const percentage = budgetData.percentages[opts.dataPointIndex];
        return percentage ? `${percentage}%` : '';
      },
      style: {
        fontSize: '11px',
        fontWeight: '600',
        colors: ['#6B7280']
      },
      offsetY: -20
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: budgetData.categories,
      labels: {
        style: {
          colors: '#6B7280',
          fontSize: '11px'
        }
      },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return val >= 1000 ? `${(val/1000).toFixed(0)},${String(val).slice(-3)}` : val;
        },
        style: {
          colors: '#6B7280',
          fontSize: '11px'
        }
      }
    },
    fill: {
      opacity: 1
    },
    colors: ['#F8BBD9', '#D8B4FE'],
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'right',
      fontSize: '12px',
      markers: {
        width: 10,
        height: 10,
        radius: 2
      }
    },
    grid: {
      borderColor: '#F3F4F6',
      strokeDashArray: 3
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `$${val.toLocaleString()}`;
        }
      }
    }
  };

  const budgetChartSeries = [
    {
      name: 'Expected',
      data: budgetData.expected
    },
    {
      name: 'Actual',
      data: budgetData.actual
    }
  ];

  const growthChartOptions = {
    chart: {
      type: 'line',
      height: 350,
      toolbar: { show: false },
      background: 'transparent'
    },
    stroke: {
      width: 3,
      curve: 'smooth'
    },
    colors: ['#A855F7'],
    xaxis: {
      categories: expenseGrowthData.categories,
      labels: {
        style: {
          colors: '#6B7280',
          fontSize: '11px'
        }
      },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return `${val}%`;
        },
        style: {
          colors: '#6B7280',
          fontSize: '11px'
        }
      }
    },
    grid: {
      borderColor: '#F3F4F6',
      strokeDashArray: 3
    },
    markers: {
      size: 6,
      colors: ['#A855F7'],
      strokeColors: '#fff',
      strokeWidth: 2
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${val}%`;
        }
      }
    }
  };

  const growthChartSeries = [
    {
      name: 'Growth',
      data: expenseGrowthData.growth
    }
  ];

  const handleTabClick = (category) => {
    setSelectedCategory(category);
    // You can add your custom function logic here
    console.log(`${category} tab clicked`);
  };

  const categories = ['Income', 'Expenses', 'Bills', 'Debts', 'Savings'];


 
    return (
    <div style={{
      backgroundColor: '#ffffff',
      width:"100%",
    //   minHeight: '100vh',
      padding: '24px',
    //   fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      {/* Header Section */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '32px',
        gap: '32px'
      }}>
        {/* Left Panel - Actual vs Budget */}
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
          padding: '24px',
          flex: '2',
          minHeight: '550px'
        }}>
          {/* Tab Navigation */}
          <div style={{
            display: 'flex',
            gap: '2px',
            marginBottom: '24px',
            backgroundColor: '#F9FAFB',
            padding: '4px',
            borderRadius: '12px'
          }}>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => handleTabClick(category)}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  backgroundColor: selectedCategory === category ? '#DC2626' : 'transparent',
                  color: selectedCategory === category ? '#ffffff' : '#6B7280'
                }}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Chart Title and Stats */}
          <div style={{ marginBottom: '20px',display:"flex",
         
          flexWrap:"wrap",
          justifyContent:"space-between", }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1F2937',
              margin: '0 0 8px 0'
            }}>
              Actual vs Budget
            </h2>
            <div style={{
              display: 'flex',
              gap: '32px',
              fontSize: '12px',
              color: '#6B7280'
            }}>
              <div>
                <span style={{ fontWeight: '600' }}>Jun 2023</span>
                <div style={{ color: '#1F2937', fontWeight: '700', fontSize: '16px' }}>2,930.00</div>
                <div>Max. Expenses</div>
              </div>
              <div>
                <span style={{ fontWeight: '600' }}>Oct 2023</span>
                <div style={{ color: '#1F2937', fontWeight: '700', fontSize: '16px' }}>2,230.00</div>
                <div>Min. Expenses</div>
              </div>
            </div>
          </div>

          {/* Budget Chart */}
          <Chart 
            options={budgetChartOptions}
            series={budgetChartSeries}
            type="bar"
            height={320}
          />
        </div>

        {/* Right Panel - Expenses Growth */}
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
          padding: '24px',
          flex: '1',
          display:"flex",
          flexDirection:"column",
          flexWrap:"wrap",
          justifyContent:"space-between",
          minHeight: '550px'
        }}>
          {/* Growth Stats */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '24px'
          }}>
            <div>
              <h2 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#1F2937',
                margin: '0 0 16px 0'
              }}>
                {selectedCategory ?? ""} Growth
              </h2>
            </div>
            <div style={{
              display: 'flex',
              gap: '24px',
              fontSize: '12px'
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: '#6B7280', marginBottom: '4px' }}>Jun 2023</div>
                <div style={{ fontSize: '24px', fontWeight: '700', color: '#1F2937' }}>13%</div>
                <div style={{ color: '#16A34A', fontSize: '11px' }}>Highest Expenses Growth</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ color: '#6B7280', marginBottom: '4px' }}>Oct 2023</div>
                <div style={{ fontSize: '24px', fontWeight: '700', color: '#1F2937' }}>-14%</div>
                <div style={{ color: '#DC2626', fontSize: '11px' }}>Lowest Expenses Growth</div>
              </div>
            </div>
          </div>

          {/* Growth Chart */}
          <Chart 
            options={growthChartOptions}
            series={growthChartSeries}
            type="line"
            height={320}
          />
        </div>
      </div>
    </div>
  
  )
}

export default SubHeadGraphs